import React, { FC } from 'react';
import { IIconSvg } from '../../components/ui/IconSvg/types';

const IconSvgPayment: FC<IIconSvg> = ({ name, w, h }) => {
  switch (name) {
    case 'text':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '24'}
          height={h || '24'}
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M1.99 5.93V4.42c0-1.02.83-1.85 1.85-1.85h12.92c1.02 0 1.85.83 1.85 1.85v1.51M10.3 18.1V3.32M6.9 18.1h5.58M13.68 10.34h7.01c.73 0 1.32.59 1.32 1.32v.8M16.08 21.43V10.87M13.94 21.43h4.28'
          />
        </svg>
      );
    case 'img':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '24'}
          height={h || '24'}
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='m21.68 16.96-3.13-7.31c-1.06-2.48-3.01-2.58-4.32-.22l-1.89 3.41c-.96 1.73-2.75 1.88-3.99.33l-.22-.28c-1.29-1.62-3.11-1.42-4.04.43l-1.72 3.45C1.16 19.17 2.91 22 5.59 22h12.76c2.6 0 4.35-2.65 3.33-5.04ZM6.97 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
          />
        </svg>
      );
    case 'img-fill':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '16'}
          height={h || '16'}
          fill='none'
          viewBox='0 0 16 16'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M4.312 5.334a2.493 2.493 0 1 0 0-4.986 2.493 2.493 0 0 0 0 4.986Zm11.1 6.225-2.308-5.4c-.42-.988-1.047-1.548-1.763-1.585-.708-.037-1.394.457-1.917 1.401L8.022 8.49c-.295.531-.715.849-1.172.886-.465.044-.93-.2-1.306-.68l-.162-.206c-.524-.656-1.173-.973-1.837-.907-.664.067-1.232.524-1.608 1.269L.661 11.396a2.93 2.93 0 0 0 .126 2.862 2.926 2.926 0 0 0 2.5 1.394h9.411c.989 0 1.91-.494 2.457-1.32.56-.826.649-1.866.258-2.773Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'image-text':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '16'}
          height={h || '10'}
          fill='none'
          viewBox='0 0 16 10'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M8.44 1.459a.398.398 0 0 0-.385.407v.724c0 .265-.204.48-.454.48a.467.467 0 0 1-.455-.48v-.724c0-.753.58-1.366 1.295-1.366h5.867c.714 0 1.294.613 1.294 1.366v.724c0 .265-.203.48-.454.48a.467.467 0 0 1-.454-.48v-.724a.398.398 0 0 0-.386-.407h-2.481v6.486h.807c.251 0 .455.214.455.48 0 .264-.204.479-.455.479H11.39a.439.439 0 0 1-.033 0h-1.255a.467.467 0 0 1-.455-.48c0-.265.204-.48.455-.48h.817V1.46H8.441Z'
            clipRule='evenodd'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.8'
            d='M7.995 6.812 6.947 4.363C6.592 3.533 5.938 3.5 5.5 4.29l-.633 1.142c-.322.58-.921.63-1.337.11l-.073-.093c-.433-.543-1.042-.476-1.354.144l-.576 1.155A1.208 1.208 0 0 0 2.606 8.5H6.88c.87 0 1.457-.888 1.115-1.688Z'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.734'
            d='M2.887 2.927a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'
          />
        </svg>
      );
    case 'double':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '42'}
          height={h || '37'}
          fill='none'
          viewBox='0 0 42 37'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='m29.868.567 3.001.694c7.53 1.744 9.83 5.428 8.07 12.866l-1.762 7.44c-1.51 6.424-4.493 9.022-10.1 8.488a19.06 19.06 0 0 1-2.911-.48l-3.02-.712c-7.494-1.762-9.812-5.428-8.05-12.867l1.76-7.457c.36-1.512.791-2.83 1.33-3.915C20.29.318 23.866-.839 29.868.567Zm-4.45 10.473a2.539 2.539 0 0 0 3.113-1.817c.364-1.37-.441-2.778-1.797-3.145a2.539 2.539 0 0 0-3.112 1.816c-.363 1.37.441 2.778 1.797 3.146Zm9.289 9.155-.849-5.989c-.153-1.096-.623-1.82-1.317-2.048-.688-.226-1.494.083-2.258.883l-2.044 2.13c-.43.45-.928.653-1.388.568-.47-.08-.863-.446-1.106-1.024l-.106-.249c-.342-.793-.898-1.281-1.569-1.392-.67-.111-1.35.193-1.918.834L20.225 16.1a3.044 3.044 0 0 0-.632 2.881 2.998 2.998 0 0 0 2.094 2.054l9.267 2.51a2.975 2.975 0 0 0 2.767-.659 2.992 2.992 0 0 0 .986-2.691ZM15.883 5.97a26.005 26.005 0 0 0-.617 2.194l-1.761 7.458v.001a28.53 28.53 0 0 0-.155.69L7.714 18.08c-.812.258-1.282 1.113-1.036 1.91a1.518 1.518 0 0 0 1.915.988l4.32-1.355c-.051 1.3.066 2.51.388 3.628l-3.54 1.108c-.812.257-1.282 1.112-1.036 1.909a1.518 1.518 0 0 0 1.916.988l4.02-1.258c1.698 2.258 4.507 3.602 8.11 4.45l3.014.71h.002c.415.1.823.186 1.223.26-.895 1.077-2.16 1.974-3.818 2.729-.834.396-1.777.75-2.83 1.062l-3.043.914c-7.551 2.272-11.483.222-13.722-7.238L1.35 21.409c-.454-1.518-.744-2.9-.82-4.133-.335-4.872 2.248-7.718 8.294-9.543l3.018-.92c1.482-.45 2.824-.734 4.042-.843Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'text-round':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='56'
          height='56'
          fill='none'
          viewBox='0 0 56 56'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Zm-9.058-36.891a.98.98 0 0 0-.973.981v1.743a1.15 1.15 0 0 1-1.145 1.154 1.15 1.15 0 0 1-1.144-1.154V20.09c0-1.815 1.462-3.29 3.262-3.29h14.785c1.8 0 3.262 1.475 3.262 3.29v1.743a1.15 1.15 0 0 1-1.144 1.154 1.15 1.15 0 0 1-1.145-1.154V20.09a.98.98 0 0 0-.973-.981H27.48v15.618h1.35a1.15 1.15 0 0 1 1.144 1.155 1.15 1.15 0 0 1-1.144 1.154h-6.386a1.15 1.15 0 0 1-1.144-1.154 1.15 1.15 0 0 1 1.144-1.155h2.747V19.11h-6.248Zm10.116 7.814a1.15 1.15 0 0 1 1.145-1.154h8.022a2.665 2.665 0 0 1 2.655 2.678v.924a1.15 1.15 0 0 1-1.144 1.154 1.15 1.15 0 0 1-1.145-1.154v-.924a.366.366 0 0 0-.366-.37h-4.131v10.494h1.304a1.15 1.15 0 0 1 1.144 1.154 1.15 1.15 0 0 1-1.144 1.155H30.5a1.15 1.15 0 0 1-1.145-1.155 1.15 1.15 0 0 1 1.145-1.154h1.305V28.078h-1.602c-.317 0-.604-.13-.811-.34a1.156 1.156 0 0 1-.334-.814Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'img-round':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '56'}
          height={h || '56'}
          fill='none'
          viewBox='0 0 56 56'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Zm-5.938-32.293a4.014 4.014 0 1 0 0-8.027 4.014 4.014 0 0 0 0 8.027ZM39.934 33.73l-3.716-8.693c-.677-1.591-1.687-2.494-2.839-2.553-1.14-.06-2.244.736-3.087 2.256l-2.256 4.05c-.475.855-1.152 1.365-1.888 1.425-.748.07-1.497-.321-2.102-1.093l-.261-.332c-.844-1.057-1.889-1.568-2.957-1.461-1.07.107-1.983.843-2.59 2.042l-2.053 4.097a4.718 4.718 0 0 0 .202 4.608 4.711 4.711 0 0 0 4.025 2.244h15.152a4.736 4.736 0 0 0 3.955-2.126 4.648 4.648 0 0 0 .415-4.465Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'double-round':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='56'
          height='56'
          fill='none'
          viewBox='0 0 56 56'
        >
          <path
            fill='#fff'
            fillRule='evenodd'
            d='M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Zm6.46-41.585 2.186.507c5.486 1.276 7.161 3.971 5.878 9.413l-1.283 5.441c-1.1 4.7-3.273 6.6-7.357 6.21a13.833 13.833 0 0 1-2.12-.351l-2.2-.521c-5.46-1.289-7.148-3.97-5.865-9.412l1.283-5.455c.262-1.107.576-2.07.968-2.864 1.532-3.15 4.137-3.997 8.51-2.968Zm-3.241 7.66a1.849 1.849 0 0 0 2.267-1.328c.265-1.002-.321-2.032-1.309-2.301a1.849 1.849 0 0 0-2.267 1.329c-.265 1.002.321 2.032 1.309 2.3Zm6.766 6.698-.618-4.38c-.112-.802-.454-1.333-.96-1.5-.5-.164-1.088.062-1.645.647l-1.489 1.558c-.313.329-.676.478-1.01.415-.343-.058-.63-.326-.807-.748l-.076-.182c-.25-.58-.654-.938-1.143-1.02-.49-.08-.985.142-1.398.61l-1.404 1.605a2.233 2.233 0 0 0-.46 2.107c.219.74.79 1.303 1.526 1.503l6.75 1.836a2.16 2.16 0 0 0 2.016-.482c.56-.492.824-1.232.718-1.969ZM24.272 18.368a19.046 19.046 0 0 0-.449 1.605l-1.283 5.455c-.04.17-.078.339-.113.505l-4.105 1.293c-.592.189-.934.814-.755 1.397.18.583.804.911 1.395.723l3.147-.991c-.037.95.048 1.837.283 2.654l-2.579.81c-.591.189-.934.814-.755 1.397.18.583.804.911 1.396.723l2.928-.92c1.237 1.65 3.283 2.634 5.908 3.254l2.195.52h.002c.303.073.6.136.891.19-.652.788-1.574 1.444-2.78 1.997-.608.29-1.296.548-2.062.777l-2.217.668c-5.501 1.662-8.365.163-9.996-5.295l-1.638-5.469c-.33-1.11-.542-2.121-.597-3.023-.244-3.564 1.637-5.646 6.041-6.98l2.2-.674c1.079-.33 2.056-.537 2.943-.617Z'
            clipRule='evenodd'
          />
        </svg>
      );
    case 'microphone':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '24'}
          height={h || '24'}
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M12 15.5c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4S8 3.79 8 6v5.5c0 2.21 1.79 4 4 4Z'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M4.35 9.65v1.7C4.35 15.57 7.78 19 12 19c4.22 0 7.65-3.43 7.65-7.65v-1.7M10.61 6.43c.9-.33 1.88-.33 2.78 0M11.2 8.55c.53-.14 1.08-.14 1.61 0M12 19v3'
          />
        </svg>
      );
    case 'video':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '24'}
          height={h || '24'}
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M22 15V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7ZM2.52 7.11h18.96M8.52 2.11v4.86M15.48 2.11v4.41'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='M9.75 14.45v-1.2c0-1.54 1.09-2.17 2.42-1.4l1.04.6 1.04.6c1.33.77 1.33 2.03 0 2.8l-1.04.6-1.04.6c-1.33.77-2.42.14-2.42-1.4v-1.2 0Z'
          />
        </svg>
      );
    case 'game':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={w || '24'}
          height={h || '24'}
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeWidth='1.5'
            d='m9.57 12.46-3.05 3.05M6.55 12.49l3.05 3.05M13.53 14h.01M17.47 14h.01M15.5 15.98v-.02M15.5 12.04v-.02'
          />
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M9 22h6c5 0 7-2 7-7v-2c0-5-2-7-7-7H9c-5 0-7 2-7 7v2c0 5 2 7 7 7ZM13.01 2 13 3.01A1 1 0 0 1 12 4h-.03c-.55 0-.99.45-.99 1s.45 1 1 1h1'
          />
        </svg>
      );
    case 'flash':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          fill='none'
        >
          <path
            fill='#fff'
            d='M11.94 7.147H9.88v-4.8c0-1.12-.607-1.347-1.347-.507L8 2.447 3.487 7.58c-.62.7-.36 1.273.573 1.273h2.06v4.8c0 1.12.607 1.347 1.347.507L8 13.553l4.513-5.133c.62-.7.36-1.273-.573-1.273Z'
          />
        </svg>
      );
    case 'flash-round':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='31'
          height='32'
          fill='none'
        >
          <circle
            cx='15.5'
            cy='16'
            r='14'
            fill='url(#levin)'
            stroke='#fff'
            strokeWidth='3'
          />
          <path
            fill='#fff'
            d='M20.164 14.99h-2.439V9.308c0-1.326-.718-1.594-1.594-.6l-.631.718-5.342 6.077c-.734.828-.427 1.507.678 1.507h2.439v5.682c0 1.326.718 1.594 1.594.6l.631-.719 5.343-6.076c.733-.829.426-1.507-.68-1.507Z'
          />
          <defs>
            <linearGradient
              id='levin'
              x1='-8.937'
              x2='25.837'
              y1='36.745'
              y2='49.749'
              gradientUnits='userSpaceOnUse'
            >
              <stop offset='.016' stopColor='#FF4066' />
              <stop offset='.673' stopColor='#EEDF53' />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'infinity':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='19'
          height='11'
          fill='none'
        >
          <path
            fill='#fff'
            d='M0 5.596V5.37c0-.73.114-1.416.342-2.06a5.464 5.464 0 0 1 .986-1.72c.43-.5.944-.891 1.543-1.171.6-.28 1.27-.42 2.012-.42.69 0 1.302.13 1.836.39.54.255 1.009.587 1.406.997.397.41.732.853 1.006 1.328.273.475.498.94.674 1.396.175.45.309.837.4 1.162v.342a13.37 13.37 0 0 1-.4 1.172c-.176.456-.4.928-.674 1.416a7.11 7.11 0 0 1-1.006 1.358 4.845 4.845 0 0 1-1.396 1.015c-.534.26-1.143.39-1.827.39-.748 0-1.425-.14-2.03-.42a4.715 4.715 0 0 1-1.544-1.171 5.488 5.488 0 0 1-.986-1.709A6.222 6.222 0 0 1 0 5.596Zm2.314-.225v.225c0 .481.056.93.166 1.347.118.417.29.785.518 1.104.228.319.508.566.84.742.332.176.713.264 1.142.264.424 0 .801-.095 1.133-.283.332-.19.622-.43.87-.723.253-.3.465-.609.634-.928.17-.319.303-.615.4-.889a4.59 4.59 0 0 0 .186-.615v-.342a4.532 4.532 0 0 0-.185-.595 6.628 6.628 0 0 0-.4-.87 4.716 4.716 0 0 0-.626-.908 3.004 3.004 0 0 0-.879-.712 2.325 2.325 0 0 0-1.152-.284c-.423 0-.8.091-1.133.274a2.504 2.504 0 0 0-.84.752c-.221.319-.39.69-.508 1.113-.11.417-.166.86-.166 1.328Zm16.524 0v.225c0 .729-.117 1.419-.352 2.07a5.243 5.243 0 0 1-.986 1.709c-.43.495-.947.885-1.553 1.172-.599.28-1.27.42-2.011.42-.69 0-1.303-.13-1.836-.39-.534-.261-1-.6-1.397-1.016a7.111 7.111 0 0 1-1.006-1.358c-.273-.488-.498-.96-.674-1.416-.175-.456-.309-.846-.4-1.172v-.342c.091-.325.225-.712.4-1.162.176-.455.4-.92.674-1.396a7.05 7.05 0 0 1 1.016-1.328c.397-.41.863-.742 1.396-.996C12.643.13 13.26 0 13.955 0c.736 0 1.403.14 2.002.42.605.28 1.123.67 1.553 1.172.43.495.758 1.068.986 1.719.228.644.342 1.33.342 2.06Zm-2.315.225V5.37c0-.469-.058-.911-.175-1.328a3.508 3.508 0 0 0-.518-1.113 2.415 2.415 0 0 0-.83-.752 2.26 2.26 0 0 0-1.123-.274c-.436 0-.824.095-1.162.284-.332.182-.625.42-.88.712a5.385 5.385 0 0 0-.624.909c-.17.312-.303.602-.4.869-.098.267-.16.465-.186.595v.342c.026.137.088.342.185.615.098.274.232.57.4.89.17.318.378.627.626.927.254.293.547.534.879.723.332.188.713.283 1.142.283.424 0 .801-.088 1.133-.264.332-.176.612-.423.84-.742.228-.32.4-.687.518-1.104.117-.416.175-.866.175-1.347Z'
          />
        </svg>
      );
    default:
      return <></>;
  }
};

export default IconSvgPayment;
